import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Inject, Injectable } from '@angular/core';
import { defer, NEVER } from 'rxjs';
import { finalize, share } from 'rxjs/operators';
import { SpinnerComponent } from './spinner-component';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    overlayRef: any = undefined;

    constructor(@Inject(Overlay) private readonly overlay: Overlay) { }

    private show(): void {
        Promise.resolve(null).then(() => {
            this.overlayRef = this.overlay.create({
                positionStrategy: this.overlay
                    .position()
                    .global()
                    .centerHorizontally()
                    .centerVertically(),
                hasBackdrop: true,
            });
            this.overlayRef.attach(new ComponentPortal(SpinnerComponent));
        });
    }

    private hide(): void {
        this.overlayRef.detach();
        this.overlayRef = undefined;
    }

    public readonly spinner$ = defer(() => {
        this.show();
        return NEVER.pipe(
            finalize(() => {
                this.hide();
            })
        );
    }).pipe(share());
}